import { Component, OnInit } from '@angular/core';
import 'lg-zoom.js';
import 'lg-share.js';
import 'lg-video.js';
import 'lg-pager.js';
import 'lg-autoplay.js';
import 'lg-fullscreen.js';
import 'lg-hash.js';
import 'lg-thumbnail.js';
declare var lightGallery: any;   


@Component({
  selector: 'app-badminton-tournament',
  templateUrl: './badminton-tournament.component.html',
  styleUrls: ['./badminton-tournament.component.scss']
})
export class BadmintonTournamentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  ngAfterViewInit() {
    /*---------------------------
    :: lightBox Gallery
    -----------------------------*/
 
    let gall_image = document.getElementsByClassName('lightgallery');
    for (const gal of gall_image) {
      lightGallery(gal), {
        selector: 'a',
      }
    }

  }



}
